export const lengthRE = /Product Length/i;
export const heightRE = /Product Height/i;
export const widthRE = /Product Width/i;
export const safeSampleLimit = 16;
export const ITEM_DOMAINS = ['identifiers'];
export const SAMPLE_DOMAINS = [
  'identifiers',
  'specificationGroup',
  'availabilityType',
  'media',
  'fulfillment',
  'pricing'
];
